import React from 'react';
import { motion } from 'framer-motion';
import { Award, Lock, Zap, DollarSign, Building2, Scale } from 'lucide-react';
const advantages = [{
  icon: <Award size={28} strokeWidth={1.5} data-id="element-31" />,
  title: '20 років без помилок',
  description: 'Знаємо всі вимоги ДПС, ПФУ та статистики. Документи проходять з першого разу.'
}, {
  icon: <Lock size={28} strokeWidth={1.5} data-id="element-32" />,
  title: 'Конфіденційність',
  description: 'Повна захищеність даних клієнта. Персональний підхід.'
}, {
  icon: <Zap size={28} strokeWidth={1.5} data-id="element-33" />,
  title: "Зв'язок 24/7",
  description: 'Відповідаємо оперативно. Більшість питань — у день звернення.'
}, {
  icon: <DollarSign size={28} strokeWidth={1.5} data-id="element-34" />,
  title: 'Фіксована ціна',
  description: 'Без прихованих комісій. Узгоджена ціна не змінюється.'
}, {
  icon: <Building2 size={28} strokeWidth={1.5} data-id="element-35" />,
  title: 'Офіс у центрі',
  description: 'Зручне розташування, безкоштовне паркування для клієнтів.'
}, {
  icon: <Scale size={28} strokeWidth={1.5} data-id="element-36" />,
  title: 'Юридичний супровід',
  description: 'За потреби — повний юридичний супровід у пакеті.'
}];
export function Advantages() {
  return <section className="py-24 bg-background" data-id="element-37">
      <div className="max-w-7xl mx-auto px-6" data-id="element-38">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-39">
          <h2 className="text-3xl md:text-4xl font-semibold" data-id="element-40">
            Чому обирають мене
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-41">
          {advantages.map((adv, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-surface p-8 rounded-3xl border border-border hover:border-primary/50 transition-colors duration-300" data-id="element-42">
              <div className="w-14 h-14 bg-background rounded-2xl flex items-center justify-center text-primary mb-6 border border-border group-hover:scale-110 transition-transform duration-500" data-id="element-43">
                {adv.icon}
              </div>
              <h3 className="text-xl font-medium mb-3" data-id="element-44">{adv.title}</h3>
              <p className="text-secondary leading-relaxed text-sm" data-id="element-45">
                {adv.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}